const SET_SYSTEM_MESSAGE = (state, payload) => {
  state.systemMessage = payload
}

export default {
  SET_SYSTEM_MESSAGE
}
